import { initLibrary } from './pages/library';
import { initUpdates } from './pages/updates';
import { initHistory } from './pages/history';
import { initBrowse } from './pages/browse';
import { initNovel } from './pages/novel';
import { initAnime } from './pages/anime';
import { initReader } from './pages/reader';
import { initMore } from './pages/more';
import { initSettings } from './pages/settings';
import { initCtrlprof } from './pages/ctrlprof';
import { initFriends } from './pages/friends';
import { initRecommendations } from './pages/recommendations';
import { registerServiceWorker } from './pwa';
import { installImageFallback } from './img-fix';
import { mountLegalNotice, mountLegalNoticeWhenLoaded } from './legal';

installImageFallback();
registerServiceWorker();

const page = document.body.dataset.page;

const handlers: Record<string, () => void | Promise<void>> = {
  library: initLibrary,
  updates: initUpdates,
  history: initHistory,
  browse: initBrowse,
  novel: initNovel,
  anime: initAnime,
  reader: initReader,
  more: initMore,
  settings: initSettings,
  ctrlprof: initCtrlprof,
  friends: initFriends,
  recommendations: initRecommendations,
};

// Юридична примітка: «Більше» (з формою входу) і каталог для гостей. Сторінка твору — у pages/novel.ts.
// У каталозі — лише після завантаження списку творів.
{
  const content = document.querySelector('.content') as HTMLElement | null;
  const grid = document.getElementById('detail-grid');
  if (content && page === 'more') void mountLegalNotice(content);
  else if (content && grid && page === 'browse') mountLegalNoticeWhenLoaded(grid, content);
}

const handler = page ? handlers[page] : undefined;
if (handler) {
  handler()!.catch?.((err: unknown) => console.error('[app] Помилка ініціалізації сторінки:', err));
} else {
  console.warn('[app] Невідома сторінка:', page);
}
